import React from "react";

import { JacobiMethodDisplay } from "~/applets";
import { ChapterWrapper } from "~/ChapterWrapper";
import { Path } from "~/paths";

export const JacobiMethodMeta = {
    title: "Jacobi Method",
    shortTitle: "Jacobi Method",
    path: Path.jacobi_method,
    element: (sectionNumber: string) => <JacobiMethod sectionNumber={sectionNumber} />,
    sectionNumber: "",
};

export function JacobiMethod({ sectionNumber }: { sectionNumber: string }) {
    return (
        <ChapterWrapper sectionNumber={sectionNumber} title={JacobiMethodMeta.title}>
            <JacobiMethodDisplay />
        </ChapterWrapper>
    );
}
